import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import formatDateLocal from "../../../services/formatDateLocal";
import RenderInputs from "../../../Components/Inputs";
import submitForm from "../../../services/submitForm";
import RenderInputsLXH from "./renderInputs";

export default function UpdateLenhXuatHang() {
  const {
    lang,
    pages,
    proxy,
    functions,
    database: { fields, tables },
  } = useSelector((state) => state);
  const { makeAutoIncreament } = functions;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setSubmit] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataTable, setDataTables] = useState([]);
  const [inputFields, setInputFields] = useState([
    {
      name: "Mã LXH/LĐĐNB",
      alias: "lenhXuatHangERP",
      type: "text",
      required: true,
      readOnly: true,
      // isNotCheck: true,
    },
    {
      name: "Saas ID",
      alias: "2MLXH",
      type: "text",
      required: true,
      readOnly: true,
      // isNotRename: true,
    },
    // {
    //   name: "LXH/LĐĐNB",
    //   alias: "LXH/LĐĐNB",
    //   type: "text",
    // },
    {
      name: "Ngày Xuất",
      alias: "2NXH",
      type: "date",
    },
    {
      name: "Kho Xuất",
      alias: "18MK",
      type: "select",
      table_id: 21719,
      displayFields: ["11MK", "8LK"],
      isApi: "/api/LXH/optionKhoXuat",
      required: true,
      isPK: "11MK",
    },
    {
      name: "Số Lượng Cần Xuất (Tấn)",
      alias: "5SLCXTT",
      type: "float",
    },
    {
      name: "Đơn Vị Phân Phối đến",
      alias: "3MNPP",
      type: "select",
      table_id: 21669,
      displayFields: ["2MNPP"],
      required: true,
      isPK: "2MNPP",
    },
    {
      name: "Kho Đến",
      alias: "2KĐ",
      type: "select",
      table_id: 21719,
      displayFields: ["11MK", "8LK"],
      required: true,
      isPK: "11MK",
    },
    {
      name: "Mã Thành Phẩm",
      alias: "28MSP",
      type: "select",
      table_id: 21692,
      displayFields: ["22MSP", "10TSP"],
      required: true,
      isMulti: true,
      isPK: "22MSP",
      isTable: {
        headers: [
          {
            label: "Số Chuyến",
            value: "delivery_detail_id",
            readOnly: true,
            type: "text",
            styles: {
              textAlign: "center",
            },
          },
          {
            label: "Mã Thành Phẩm",
            value: ["mathanhpham", "tenthanhpham"],
            readOnly: true,
            styles: {
              textAlign: "left",
            },
          },
          {
            label: "Số Lượng Cần Xuất (Tấn)",
            value: "soluongcanxuat",
            type: "number",
            styles: {
              textAlign: "center",
            },
          },
        ],
      },
    },
    {
      name: "Ghi Chú",
      alias: "ghiChuLenhXuatHangLXH",
      type: "textarea",
    },
  ]);

  const _token = localStorage.getItem("_token");
  const param = useParams();

  useEffect(() => {
    const tableId = 22577;
    const api_id = [];

    pages
      .filter(({ is_hidden }) => !is_hidden)
      .forEach((page) => {
        page.children
          .filter(({ is_hidden }) => !is_hidden)
          .forEach((child) => {
            child.component.forEach((item) => {
              const { props } = item;
              const findId = props.source?.tables?.find(
                (item) => item.id === tableId
              );
              if (findId) {
                const currentPage = pages.find((p) => p.block === item.id)
                  ?.component?.[0]?.children;

                if (currentPage) {
                  const mappedFields = currentPage
                    .map((item) => {
                      const {
                        props: {
                          variable_name,
                          title: { content, visible },
                          required,
                          displayField,
                          betChar,
                          textarea,
                        },
                      } = item;
                      if (!visible) return null;

                      const field = inputFields.find(
                        ({ alias }) => alias === variable_name
                      );

                      if (field) {
                        const { isNotRename } = field;
                        return {
                          ...field,
                          name: isNotRename ? field.name : content,
                          alias: variable_name,
                          type: textarea ? "textarea" : field.type,
                          required,
                          betChar,
                          displayFields:
                            displayField && displayField.length
                              ? displayField?.map(({ value }) => value)
                              : field.displayFields,
                        };
                      }
                    })
                    .filter(Boolean);

                  setInputFields((prev) => [
                    ...prev.filter(({ isNotCheck }) => isNotCheck),
                    ...mappedFields,
                  ]);
                }
                setTables(findId);
                api_id.push(props?.buttons?.add?.api?.api_id);
              }
            });
          });
      });

    fetch(`${proxy()}/apis/api/${api_id?.[0]}/input_info`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setDefaultValues(res.data.display_fields);
      });
  }, [pages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(proxy() + `/api/LXH/${param.id}`, {
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
        });
        const res = await response.json();
        const { success, data, message } = res;
        if (success && data) {
          setDataTables(data?.details);
          const selectedValuesTemp = {};
          // setValue("details", data?.details || []);
          for (const item of inputFields) {
            // if (data[item.alias]) {
            const opts = [];
            const table_id = item?.table_id;
            const { betChar, isPK } = item;
            if (item.child) {
              for (const child of item.child) {
                const table_id = child?.table_id;
                if (table_id) {
                  const foreignResponse = await ForeignData_API.get(
                    proxy(),
                    _token,
                    { table_id }
                  );
                  const { data: foreignData = [] } = foreignResponse;

                  if (foreignData.length) {
                    foreignData.forEach((item) => {
                      const fields = child?.displayFields?.map(
                        (field) => item[field]
                      );
                      // opts.push({ label: fields.join("_"), value: fields[0] });
                      opts.push({
                        label: fields.join(betChar ? betChar : "|"),
                        value: item[child.isPK],
                      });
                    });

                    setValue(child.alias, data[child.alias]);
                  }
                }
              }
              setOptions(opts);
            }

            if (item.type === "select" || item.type === "input-select") {
              let dataBody = {
                table_id,
                start_index: 0,
                type: "or",
              };

              dataBody["criteria"] = { [isPK]: data[item.alias] };
              dataBody["criteria_type"] = { [item.alias]: "regex" };

              const foreignResponse = await ForeignData_API.get(
                proxy(),
                _token,
                dataBody
              );
              const { data: foreignData = [] } = foreignResponse;
              if (foreignData.length) {
                const result = foreignData.reduce((acc, curr) => {
                  const checkEmpty = Array.isArray(data[item.alias])
                    ? data[item.alias].some((item) => item === curr[isPK])
                    : curr[isPK] === data[item.alias];

                  if (checkEmpty) {
                    const fields = item?.displayFields?.map(
                      (field) => curr[field]
                    );
                    if (
                      fields.every((val) => val === undefined || val === null)
                    )
                      return acc;

                    const label = fields.join(betChar ?? "|");
                    const option = {
                      label,
                      value: curr[isPK],
                      ...item,
                    };

                    opts.push(option);
                    // selectedValuesTemp[item?.alias] = option;
                    acc.push(option);
                  }
                  return acc;
                }, []);

                if (result.length) {
                  setSelectedValues((prev) => ({
                    ...prev,
                    [item?.alias]: item?.isMulti ? result : result?.[0],
                  }));
                }

                selectedValuesTemp[item?.alias] = result;
              }
            } else if (item.type === "input-select") {
              setOptions(opts);
            } else {
              const formattedData = formatDateLocal(
                data[item.alias],
                item.type
              );
              setValue(item.alias, formattedData);
            }
            // }
          }
        } else {
          Swal.fire({
            title: lang["error"] || "Error",
            text: message,
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "OK",
            allowOutsideClick: false,
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              navigate(-1);
            }
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (param) {
      fetchData();
    }
  }, [inputFields]);
  console.log("CALLL HERE");

  const onSubmit = async (data) => {
    for (const property in data) {
      if (selectedValues[property]) {
        data = {
          ...data,
          [property]: Array.isArray(selectedValues[property])
            ? selectedValues[property].map((item) => item.value)
            : selectedValues[property]?.value || "",
        };
      }
    }
    const trimmedData = Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );

    const mappedData = {
      data: {
        ...trimmedData,
        details: dataTable || null,
      },
      default_field_value: defaultValues,
      table: isTables,
    };

    await submitForm({
      url: `/api/LXH/${param.id}`,
      method: "PUT",
      data: mappedData,
      proxy,
      lang,
      inputFields,
    });
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => navigate(-1)}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        Lệnh Xuất hàng
                        <i className="fa fa-chevron-right ml-2 mr-1" />
                        {lang["update"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  {loading ? (
                    <img
                      width={40}
                      className="loading-image"
                      src="/images/icon/load.gif"
                      alt="Loading..."
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                      }}
                    />
                  ) : (
                    <div className="col-md-12">
                      <div
                        style={{
                          height: "70vh",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <div className="row w-50-pct mg-auto p-1 bg-white input-put">
                          {inputFields.map((field, index) => {
                            const {
                              required,
                              name,
                              alias,
                              type,
                              col,
                              readOnly = false,
                              table_id,
                              displayFields,
                              style,
                            } = field;
                            return (
                              <>
                                <div
                                  className={`${
                                    col ? col : `col-sm-8  offset-sm-2`
                                  } mb-3`}
                                  {...register(alias)}
                                  style={style}
                                >
                                  <label class="form-label">
                                    {name}
                                    {required && (
                                      <span style={{ color: "red" }}>*</span>
                                    )}
                                  </label>
                                  <RenderInputsLXH
                                    control={control}
                                    register={register}
                                    selectedValues={selectedValues}
                                    setSelectedValues={setSelectedValues}
                                    field={field}
                                    options={options}
                                    setValue={setValue}
                                    getValues={getValues}
                                    dataTable={dataTable}
                                    setDataTables={setDataTables}
                                    isUpdate={true}
                                  />
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </div>
                      <div className="col-sm-7 offset-sm-3 p-0">
                        <div className="d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-success mr-2"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => setSubmit(true)}
                          >
                            Lưu lại
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => navigate(-1)}
                          >
                            Đóng
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
